import React, { createContext, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { IamUserRoleEnum } from '../utils/enums';
import Logger, { LOG_LEVELS } from '../utils/logger';

const log = new Logger('READ_ONLY_CONTEXT', LOG_LEVELS.DEBUG);

const ReadOnlyContext = createContext({
  isReadOnly: false,
  userRole: null,
});

export const useReadOnly = () => {
  const context = useContext(ReadOnlyContext);
  return context;
};

const ReadOnlyProviderComponent = ({ children, currentUser, iamData }) => {
  const contextValue = useMemo(() => {
    const userRole = iamData?.vatReportingRole;
    const isReadOnly = userRole === IamUserRoleEnum.READ_ONLY.value;
    
    log.debug('ReadOnlyContext value:', { isReadOnly, userRole, iamData });
    
    return {
      isReadOnly,
      userRole,
      currentUser,
    };
  }, [currentUser, iamData]);

  return (
    <ReadOnlyContext.Provider value={contextValue}>
      {children}
    </ReadOnlyContext.Provider>
  );
};


const mapStateToProps = (state) => ({
  currentUser: state.authentication?.data,
  iamData: state.authentication?.data?.iamData,
});

export const ReadOnlyProvider = connect(mapStateToProps)(ReadOnlyProviderComponent);

export default ReadOnlyContext;

